// 类型
export enum offTypes {
    '商品溢价' = 1,
    '折扣不合格',
    '信息有误',
    '质量问题',
    '口感不佳',
    '永久下架' = 10,
    '整改下架' = 11,
}
// 筛选类型
export enum filterTypes {
    '其他',
    '商品溢价',
    '折扣不合格',
    '信息有误',
    '质量问题',
    '口感不佳',
    '延迟发货',
    '品牌资质过期',
    '自行下架',
    '库存不足',
    '永久下架',
    '整改下架'
}
export enum deliveryTypes {
    '待发货' = 1,
    '48h未发货',
}
export enum NoticeStatus {
    '已读' = 1,
    '未读',
}

